// ZohoScript.tsx
import React, { useEffect } from 'react';

declare global {
  interface Window {
    $zoho: any;
  }
}

const ZohoScript: React.FC = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'zsiqscript';
    script.src = 'https://salesiq.zohopublic.com/widget?wc=siq8a9ab49082466db41d9274e1440ee5307c345c59a28b00faa3cd42adcb2842bd';
    script.defer = true;

    document.body.appendChild(script);

    window.$zoho = window.$zoho || {};
    window.$zoho.salesiq = window.$zoho.salesiq || {
      ready: function () {
        window.$zoho.salesiq.visitor.chat();
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
};

export default ZohoScript;
